"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function Previous(props) {
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 128 128", preserveAspectRatio: "xMidYMid" }, props),
        React.createElement("path", { d: "M29.09 53.749V5.819H5.819v116.363h23.273v-47.93L122.18 128V0z", fill: "currentColor" })));
}
exports.default = Previous;
//# sourceMappingURL=Previous.js.map